var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "#A7A7A7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhone 13 mini - 5"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2361_110688)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -461,
    width: 375,
    height: 812,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 11464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427319775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427319774"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    x: -15,
    y: -131,
    width: 327,
    height: 166,
    rx: 14,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 11475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quantity:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.21839 14C11.6226 14 14.3822 11.3137 14.3822 8C14.3822 4.68629 11.6226 2 8.21839 2C4.8142 2 2.05457 4.68629 2.05457 8C2.05457 11.3137 4.8142 14 8.21839 14Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.21838 4.5V8H11.8139",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2361_110688"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -461,
    width: 375,
    height: 812,
    rx: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBlack);
export default __webpack_public_path__ + "static/media/clock_black.44fdeeef983e4218892042363680edf2.svg";
export { ForwardRef as ReactComponent };